<template>
    <v-card
                    class="user" :class="customCss"
                    max-width="344"
            >
        <v-card-text class="text-center">
            <v-avatar>
                <img :src="default_avatar" alt="">
            </v-avatar>
            <p v-if="flag" class="mt-3 body-1 indigo--text font-weight-bold ">
                <span class="st-username">{{currentUser.username}} </span><br>
<!--                        <span class="orange&#45;&#45;text" >Vip member</span><br>-->
                <strong class="black--text st-coin">{{ currentUser.customer.coin | currency }}</strong>
            </p>
<!--            <p class="mt-3 body-1 indigo&#45;&#45;text font-weight-bold ">-->
<!--                <strong class="black&#45;&#45;text st-coin">Level: {{ currentUser.customer_level_name }}</strong>-->
<!--            </p>-->
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-list flat>
            <v-list-item-group color="primary">
                <v-list-item class="px-10" :to="`/user-profile`">
                    <v-list-item-icon>
                        <v-icon v-text="`mdi-account`"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="`Tài Khoản`"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-10" :to="`/user-payment`">
                    <v-list-item-icon>
                        <v-icon v-text="`mdi-credit-card`"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="`Nạp Tiền`"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-10" :to="`/notice`">
                    <v-list-item-icon>
                        <v-icon v-text="`mdi-bell-ring-outline`"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="`Thông Báo`"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-10" @click="logout()">
                    <v-list-item-icon>
                        <v-icon v-text="`mdi-logout`"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="`Đăng Xuất`"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-card>

</template>

<script>
import { COLOR } from "~/config/constant";
export default {
    name: "box-menu",
    components: {},
    data() {
        return {
            COLOR: COLOR,
            coin: 0,
            drawer: true,
            menu_manage: [],
            menu_seeding: [],
            default_avatar : 'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRb3cKuVSY5yQSumCbZVZJf05ere11Tt1sOSRrNYc425RBOUjS0',
            items: [
                { text: 'Thông Báo', icon: 'mdi-bell-ring-outline' },
            ],
        }
    },
    props: {
        flag: Boolean,
        currentUser: Object,
        customCss: String
    },
    methods: {
        logout() {
            this.$store.dispatch("auth_logout");
            this.$router.push("/login");
        }
    }
};
</script>
<style lang="scss">
    @import "../scss/main";
    .customer-primary-nav {
        .v-navigation-drawer {
            .menus {
                background: transparent !important;
                a {
                    color: #ffffff;
                }
                .v-list-group__header {
                    color: white !important;
                }
                .v-list-item:hover {
                    background: $clickMenuColor !important;
                    border-radius: 0 30px 30px 0 !important;
                    color: white !important;
                }
                .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
                    color: #ffffff !important;

                    .v-icon {
                        color: #ffffff !important;
                    }
                }
                .v-list-group__header.v-list-item--active {
                    //background: $clickMenuColor !important;
                    //border-radius: 0 30px 30px 0;
                    //color: white !important;
                }
                .theme--light.v-list-item--active {
                    color: $clickMenuColor;
                    opacity: 1;
                }
                .v-list-item--link:before {
                    background-color: transparent;
                }
            }
            .user {
                border-radius: 20px !important;
            }

        }
    }
</style>
